module.exports = __webpack_public_path__ + "static/media/lightroom_14b.65ec9bb2.hdr";